import React, { useEffect, useRef, useState } from 'react';
import "./style/_inputmoney.scss";
import { Form } from "react-bootstrap";
import BodyInputFormat from './BodyInputFormat';
import { IFormInputDefault } from './interfaces';
import { FormControl } from 'react-bootstrap';
import { addData, getData } from './utils';
import { makeid } from 'utils/random';

const currenciesFormar = [
  {
    decimal: ",",
    thousands: ".",
    prefix: "R$"
  },
  {
    decimal: ",",
    thousands: ".",
    prefix: "$"
  },
  {
    decimal: ",",
    thousands: ".",
    prefix: "€"
  }
]


interface IFormInputMoney{
  onChange?: (event: any) => void;
  value?: number;
  minValue?: number;
  maxValue?: number;
  disabled?: boolean;
  disabledNegative?: boolean;
  currencyFormat?: {
    decimal: string,
    thousands: string,
    prefix: string,
  };
  name?:string;
  [x:string]:any;
}

export function InputMoney({
  onChange,
  value,
  minValue = -Number.MAX_SAFE_INTEGER,
  maxValue = Number.MAX_SAFE_INTEGER,
  disabled,
  disabledNegative,
  currencyFormat = {
    decimal: ",",
    thousands: ".",
    prefix: "R$"
  },
  name,
  ...props
}:IFormInputMoney){
  const [valueOld, setValueOld] = useState("");
  const [currentValue, setCurrenctValue] = useState(value);
  const [isNegative, setIsNegative] = useState(false);
  const refAreaInputMoney = useRef(null);

  function formatValue(value:any){
  
    return (isNegative ? `-${currencyFormat.prefix} ` : `${currencyFormat.prefix} `)+value;
  }

  function removeCurrency(value:any){
    let currency = `-${currencyFormat.prefix} `;
    for (let i = 0; i < currency.length; i++) {
      value = value.replace(currency[i],"");
    }
    return value;
  }

  function ctof(value:any, valueOld:any, push:boolean = false){
    while (value.indexOf(currencyFormat.thousands)!==-1) {
      value = value.replace(currencyFormat.thousands,"");
    }
    if(value.indexOf(currencyFormat.decimal)!==-1){
      value = value.replace(currencyFormat.decimal,".");
    } else {
      value+=".00";
    }
    
    setValueOld(value);
    let num_1 = parseInt(valueOld?valueOld.replace(".",""):"0");
    let num_2 = parseInt(value.replace(".",""));
    if(num_1 < num_2){
      if(push && num_1 !== 0){
        let i = value.indexOf(".");
        if(i !== -1){
          let aux = value.substr(i,2);
          if(aux.length === 2){
            value = value.replace(aux, `${aux[1]}${aux[0]}`);
          }
        }
      }
    } else if(num_1 > num_2){
      if(push){
        let i = value.indexOf(".");
        if(i !== -1){
          let aux = value.substr(i-1,2);
          if(aux.length === 2){
            value = value.replace(aux, `${aux[1]}${aux[0]}`);
          }
        }
      }
    }

    value = parseFloat(value);
    return value?value.toFixed(2):"";
  }

  function ftoc(value:any){
    let list_aux = value.split(".");
    if(list_aux.length === 2){
      let count = 0;
      let res = "";
      for (let i = list_aux[0].length-1; i >=0; i--) {
        let character = list_aux[0][i];
        if(count===3){
          res = currencyFormat.thousands + res;
          count = 0;
        }
        res = character + res;
        count++;
      }
      return `${res}${currencyFormat.decimal}${list_aux[1]}`;
    }
    return value;
  }

  useEffect(()=>{
    if(!valueOld && value){
      let aux = value.toString();
      if(aux.indexOf(",") !== -1){
        while (aux.indexOf(currencyFormat.thousands)!==-1) {
          aux = aux.replace(currencyFormat.thousands,"");
        }
        if(aux.indexOf(currencyFormat.decimal)!==-1){
          aux = aux.replace(currencyFormat.decimal,".");
        } else {
          aux+=".00";
        }
        setValueOld(aux);
      } else {
        if(aux.indexOf(".") === -1){
          aux+=".00";
        }
        setValueOld(aux);
      }
    }
    setCurrenctValue((old) => {
      if(value && old !== value){
        let aux = value.toString();
        if(aux.indexOf(",") !== -1){
          while (aux.indexOf(currencyFormat.thousands)!==-1) {
            aux = aux.replace(currencyFormat.thousands,"");
          }
          if(aux.indexOf(currencyFormat.decimal)!==-1){
            aux = aux.replace(currencyFormat.decimal,".");
          } else {
            aux+=".00";
          }
          setValueOld(aux);
        } else {
          if(aux.indexOf(".") === -1){
            aux+=".00";
          }
          setValueOld(aux);
        }
      }
      if(value){
        return value;
      }
      return old;
    });
  },[value,valueOld, currencyFormat]);

  useEffect(()=>{
    if(!currentValue){
      setIsNegative(false);
    }
  },[currentValue]);

  function alertAnimation(target: any){
    let element:any = refAreaInputMoney.current;
    if(element){
      target.className += " alert-overflow";
      // element.className += " alert-overflow";
      setTimeout(()=>{
        target.className = target.className.replace(" alert-overflow","");
      },500);
      // setTimeout(()=>{
      //   element.className = element.className.replace(" alert-overflow","");
      //   element.className += " alert-overflow-hidden";
      //   setTimeout(()=>{
      //     element.className = element.className.replace(" alert-overflow-hidden","");
      //   },450);
      // },3000);
    }
  }

  function onChangeGlobal(e:any, valueOld:any, isNegative:any){
    let target = e.target;
    let position = target.value.length - target.selectionStart;
    let value = removeCurrency(target.value);
    let push_ctof = position < (isNegative?(currencyFormat.prefix.length+2):(currencyFormat.prefix.length+1)) && value.length > 1;

    if(value.length === 1){
      value =  `0${currencyFormat.decimal}0${value}`;
      position = 0;
    }
    
    if(parseInt(value.replace(/\D/g, "")) === 0){
      target.value = "";
      setValueOld("");
      setCurrenctValue(0);
      setIsNegative(false);
      if(onChange)onChange({...e, valueFloat:0});
    } else {
      let value_ctof = ctof(value, valueOld, push_ctof);
      let value_ftoc = ftoc(value_ctof);
      if(!value_ftoc){
        setValueOld("");
        setCurrenctValue(0);
        setIsNegative(false);
        if(onChange)onChange({...e, valueFloat:0});
        return;
      }
      e.target.value = formatValue(value_ftoc);
      setTimeout(()=>{
        let p = (formatValue(value_ftoc).length-position);
        target.setSelectionRange(p,p);
      },1);

      if(onChange)onChange({...e, valueFloat:(()=>{
        let value = removeCurrency(target.value);
        let value_ctof = ctof(value, valueOld);
        if(value_ctof){
          value_ctof = parseFloat(value_ctof);
          if(!isNaN(maxValue) && maxValue < (value_ctof*(isNegative?-1:1))){
            alertAnimation(e.target);
            value_ctof = maxValue;
            let aux = maxValue.toString();
            while (aux.indexOf(currencyFormat.thousands)!==-1) {
              aux = aux.replace(currencyFormat.thousands,"");
            }
            if(aux.indexOf(currencyFormat.decimal)!==-1){
              aux = aux.replace(currencyFormat.decimal,".");
            } else {
              aux+=".00";
            }
            setValueOld(aux);
          }
          if(!isNaN(minValue) && minValue > (value_ctof*(isNegative?-1:1))){
            alertAnimation(e.target);
            value_ctof = minValue*-1;
            let aux = (value_ctof).toString();
            while (aux.indexOf(currencyFormat.thousands)!==-1) {
              aux = aux.replace(currencyFormat.thousands,"");
            }
            if(aux.indexOf(currencyFormat.decimal)!==-1){
              aux = aux.replace(currencyFormat.decimal,".");
            } else {
              aux+=".00";
            }
            setValueOld(aux);
          }
          setCurrenctValue(value_ctof*(isNegative?-1:1))
          return value_ctof*(isNegative?-1:1)
        }
        setCurrenctValue(0)
        return 0;
      })()});
    }
  }

  return (
    <div className={"area-input-money"} style={{flex:"1 0 0%"}} ref={refAreaInputMoney}>
      <Form.Control
        name={name}
        size="sm"
        disabled={disabled}
        value={(()=>{
          if(currentValue && parseFloat(currentValue.toString())){
            let value_ftoc = parseFloat(currentValue.toString());
            if(value_ftoc < 0){
              value_ftoc *= -1;
            }
            value_ftoc = ftoc(value_ftoc.toFixed(2));
            return formatValue(value_ftoc);
          }
          return "";
        })()}
        onPaste={(e: React.ClipboardEvent<HTMLInputElement>)=>{
          let value = e.clipboardData.getData('Text');
          let isNegative = value[0] === "-";
          let res = "";
          for (let i = 0; i < value.length; i++) {
            const character = value[i];
            if((character >= "0" && character <= "9") || character === currencyFormat.decimal){
              res += character;
            }
          }
          e.currentTarget.value = res;
          e.currentTarget.setSelectionRange(res.length,res.length);
          setIsNegative(isNegative && !disabledNegative)
          onChangeGlobal(e, "", isNegative && !disabledNegative);
        }}
        onKeyPress={(e)=>{
          if (e.key >= '0' && e.key <= '9') {
            let index_start = e.currentTarget.selectionStart ?? e.currentTarget.value.length;
            let index_end = e.currentTarget.selectionEnd ?? e.currentTarget.value.length;
            let res = "";
            let enter = false;
            if(index_end !== index_start){
              let aux = e.currentTarget.value.substr(index_start, index_end);
              res = e.currentTarget.value.replace(aux,e.key);
            } else {
              for (let i = 0; i < e.currentTarget.value.length; i++) {
                const character = e.currentTarget.value[i];
                if(index_start === i){
                  res += e.key;
                  enter = true;
                }
                res += character;
                
              }
              if(!enter){
                res+=e.key;
              }
            }
            e.currentTarget.value = res;
            e.currentTarget.setSelectionRange(index_start+1,index_end+1);
            onChangeGlobal(e, valueOld, isNegative);
          }
        }}
        onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>)=>{
          let index_start,index_end;
          if(e && e.currentTarget){
            switch (e.key) {
              case "Backspace":
                index_start = (e.currentTarget.selectionStart ?? e.currentTarget.value.length)-1;
                index_end = (e.currentTarget.selectionEnd ?? e.currentTarget.value.length)-1;
                let res = "";
                for (let i = 0; i < e.currentTarget.value.length; i++) {
                  const character = e.currentTarget.value[i];
                  if(i >= index_start && i <= index_end) {
                    if((character === currencyFormat.decimal || character === currencyFormat.thousands) && index_start === index_end){
                      res += character;
                    }
                  } else {
                    res += character;
                  }
                }
                e.currentTarget.value = res;
                e.currentTarget.setSelectionRange(index_end,index_end);
                onChangeGlobal(e, valueOld, isNegative);
              break;
              case "-":
                if(!disabledNegative){
                  setIsNegative(!isNegative)
                  index_start = (e.currentTarget.selectionStart ?? e.currentTarget.value.length)+1;
                  index_end = (e.currentTarget.selectionEnd ?? e.currentTarget.value.length)+1;
                  e.currentTarget.value = (e.currentTarget.value[0]==="-")?e.currentTarget.value.substr(1,e.currentTarget.value.length):("-"+e.currentTarget.value)
                  e.currentTarget.setSelectionRange(index_start,index_end);
                  onChangeGlobal(e, valueOld, !isNegative);
                }
                break;
              default:
                break;
            }
          }
        }}
        onChange={()=>{}}
        {...props}
      />
    </div>
  );
}

interface IFormInputProps extends IFormInputDefault{
  selectCurrency?: {
    show: number[];
    selected: number;
  },
  onChangeCurrency?: (currency: number) => void;
}

export default function FormImputMoney({
  title,
  name,
  state,
  onChange,
  onChangeCurrency,
  selectCurrency,
  ...props
}:IFormInputProps){
  const [ ID ] = useState(`${makeid(10)}`)
  const [ format, setFormat ] = useState({
    decimal: ",",
    thousands: ".",
    prefix: "R$"
  });

  const [ currency, setCurrency ] = useState(1);
  
  let {cleanable, onClear, ...props_aux} = props;
  if(state && name){
    props_aux["name"] = name+"-"+ID;
    props_aux["value"] = state.model?getData(state.model,name):"";
  }

  useEffect(()=>{
    if(selectCurrency && selectCurrency.selected){
      setCurrency(selectCurrency.selected);
    }
  },[selectCurrency])

  useEffect(()=>{
    setFormat(currenciesFormar[currency-1])
  },[currency]);

  return (
    <BodyInputFormat props={{...props,title}} twoColumn={!!selectCurrency}>
      <InputMoney
        onChange={(event)=>{
          if(state && name){
            let value = event.valueFloat;
            state.setModel((old:any)=>{
              return addData(old,name,value);
            });
          }if(onChange)onChange(event)
        }} 
        currencyFormat={format}
        {...props_aux}
      />
      {selectCurrency?(
        <FormControl 
          size="sm"
          as="select"
          disabled={props_aux.disabled}
          style={{flex:"0 0 auto",width:"auto"}}
          onChange={(e)=>{
            let t = e.currentTarget;
            if(t){
              setCurrency(parseInt(t.value));
              if(onChangeCurrency)onChangeCurrency(parseInt(t.value));
            }
          }}
          value={selectCurrency && selectCurrency.selected?selectCurrency.selected:undefined}
        >
          {currenciesFormar.map((item, key)=>{
            if(selectCurrency && selectCurrency.show && selectCurrency.show.indexOf(key+1) !== -1){
              return <option key={key} value={key+1}>{item.prefix}</option>
            }
            return <React.Fragment key={key}/>;
            
          })}
        </FormControl>
      ):<></>}
    </BodyInputFormat>
  );
}